/* ==========================================================================
   Sticky product bar
   - Real Color/Size selection driven by the variant JSON embedded in
     sticky-product-bar.liquid (no hardcoded values here).
   - Grays out color/size combinations that have no in-stock variant, checked
     against whatever's currently selected in the OTHER option, both ways
     (pick color first -> unavailable sizes gray out, pick size first ->
     unavailable colors gray out).
   - Keeps the real variant id on the Add to Bag form, syncs ?variant= in the
     URL, and updates the color dot from the variant's own photo.
   - Always visible, fixed to the bottom of the viewport (no scroll-based
     show/hide).
   ========================================================================== */
;(function () {
  function initBar(bar) {
    if (!bar || bar.dataset.spbInit === 'true') return
    bar.dataset.spbInit = 'true'

    var colorIndex = parseInt(bar.dataset.colorIndex, 10)

    // One entry per product option (Color, Size, and however many more the
    // product has). Each field carries its own variant-options array index
    // in data-option-index, so nothing here assumes a fixed count of 2.
    //
    // A split-by-color product also has a "style-group" field (cross-product
    // color swatches from the style_group metaobject, sections/sticky-product-bar.liquid).
    // Its options are plain <a href> links to sibling PRODUCT pages, not a
    // variant dimension, so it's excluded from fieldList — it never carries
    // data-option-index — and stays out of all variant-matching logic below.
    var fields = bar.querySelectorAll('.spb-field')
    var fieldList = Array.prototype.filter
      .call(fields, function (field) {
        return field.dataset.optionIndex !== undefined
      })
      .map(function (field) {
        return { el: field, kind: field.dataset.field, index: parseInt(field.dataset.optionIndex, 10) }
      })
    var colorField = bar.querySelector('.spb-field[data-field="color"]')
    var hasColor = !!colorField

    var colorDot = bar.querySelector('[data-color-dot]')
    var idInput = bar.querySelector('[data-variant-id-input]')
    var submitButton = bar.querySelector('.sticky-product-bar__submit')
    var submitLabel = bar.querySelector('[data-submit-label]')

    var dataEl = bar.querySelector('[data-variant-data]')
    var variants = []
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent) || []
      } catch (e) {
        variants = []
      }
    }

    // Color starts pre-selected (matches the markup's default). Every other
    // field starts unset so shoppers always confirm it explicitly.
    var selected = {}
    fieldList.forEach(function (f) {
      selected[f.kind] = null
    })
    if (hasColor) {
      var selectedOpt = colorField.querySelector('.spb-field__option.is-selected')
      if (selectedOpt) selected.color = selectedOpt.getAttribute('data-value')
    }

    function matchesOtherSelections(variant, exceptKind) {
      for (var i = 0; i < fieldList.length; i++) {
        var f = fieldList[i]
        if (f.kind === exceptKind) continue
        if (selected[f.kind] != null && variant.options[f.index] !== selected[f.kind]) return false
      }
      return true
    }

    function fieldFor(kind) {
      for (var i = 0; i < fieldList.length; i++) {
        if (fieldList[i].kind === kind) return fieldList[i]
      }
      return null
    }

    function isValueAvailable(kind, value) {
      var field = fieldFor(kind)
      if (!field) return false
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i]
        if (v.options[field.index] === value && v.available && matchesOtherSelections(v, kind)) {
          return true
        }
      }
      return false
    }

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i]
        var matchesAll = true
        for (var j = 0; j < fieldList.length; j++) {
          var f = fieldList[j]
          if (v.options[f.index] !== selected[f.kind]) {
            matchesAll = false
            break
          }
        }
        if (matchesAll) return v
      }
      return null
    }

    function imageForColor(value) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options[colorIndex] === value && variants[i].image) {
          return variants[i].image
        }
      }
      return null
    }

    function mediaIdForColor(value) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options[colorIndex] === value && variants[i].media_id) {
          return variants[i].media_id
        }
      }
      return null
    }

    // Jumps the product gallery (sections/product-gallery.liquid) to the
    // slide for this color, matched by media id first (reliable), falling
    // back to comparing image filenames (strips Shopify's size/query params)
    // in case a variant photo isn't tagged with a media id for some reason.
    function syncGalleryForColor(value) {
      var galleryEl = document.querySelector('.product-gallery__swiper')
      if (!galleryEl || !galleryEl.swiper) return

      var slides = galleryEl.swiper.slides
      var mediaId = mediaIdForColor(value)
      var index = -1

      if (mediaId) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].dataset.mediaId === String(mediaId)) {
            index = i
            break
          }
        }
      }

      if (index < 0) {
        var image = imageForColor(value)
        if (!image) return
        // Shopify CDN inserts a "_{width}x{height}" size suffix before the
        // extension (foo_640x.jpg vs foo_3600x.jpg for the same source
        // image) — strip it so different-sized transforms of the same file
        // still compare equal.
        var stripSize = function (url) {
          return url.split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.[a-zA-Z0-9]+$)/, '')
        }
        var targetFile = stripSize(image)
        for (var j = 0; j < slides.length; j++) {
          var img = slides[j].querySelector('img[src]')
          if (img && stripSize(img.src) === targetFile) {
            index = j
            break
          }
        }
      }

      if (index >= 0) galleryEl.swiper.slideTo(index)
    }

    function refreshAvailability() {
      fieldList.forEach(function (f) {
        f.el.querySelectorAll('.spb-field__option').forEach(function (opt) {
          var value = opt.getAttribute('data-value')
          var available = isValueAvailable(f.kind, value)
          opt.classList.toggle('is-unavailable', !available)
          opt.setAttribute('aria-disabled', String(!available))
        })
      })
    }

    function refreshSubmit() {
      var missing = fieldList.some(function (f) {
        return selected[f.kind] == null
      })

      if (missing) {
        submitButton.disabled = true
        submitLabel.textContent = submitButton.dataset.labelSelect || 'Select options'
        return
      }

      var variant = findVariant()

      if (!variant) {
        submitButton.disabled = true
        submitLabel.textContent = submitButton.dataset.labelUnavailable || 'Unavailable'
        return
      }

      idInput.value = variant.id

      if (colorDot) {
        var img = variant.image || (hasColor ? imageForColor(selected.color) : null)
        if (img) colorDot.style.backgroundImage = 'url(' + img + ')'
      }

      if (!variant.available) {
        submitButton.disabled = true
        submitLabel.textContent = submitButton.dataset.labelSoldout || 'Sold out'
        return
      }

      submitButton.disabled = false
      submitLabel.textContent = submitButton.dataset.labelAdd || 'Add to Bag'

      // Keep the link shareable / refresh-safe without adding history entries.
      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href)
          url.searchParams.set('variant', variant.id)
          window.history.replaceState({}, '', url)
        } catch (e) {
          /* no-op: URL API issues shouldn't block add-to-cart */
        }
      }
    }

    function selectValue(field, kind, opt) {
      if (opt.classList.contains('is-unavailable')) return

      var value = opt.getAttribute('data-value') || ''
      var valueEl = field.querySelector('[data-field-value]')

      if (valueEl) {
        valueEl.textContent = value
        valueEl.classList.remove('spb-field__value--placeholder')
      }

      field.querySelectorAll('.spb-field__option').forEach(function (o) {
        o.classList.remove('is-selected')
        o.setAttribute('aria-selected', 'false')
      })
      opt.classList.add('is-selected')
      opt.setAttribute('aria-selected', 'true')

      selected[kind] = value

      if (kind === 'color') syncGalleryForColor(value)

      refreshAvailability()
      refreshSubmit()
    }

    function closeAll(except) {
      fields.forEach(function (f) {
        if (f === except) return
        var trigger = f.querySelector('.spb-field__trigger')
        var menu = f.querySelector('.spb-field__menu')
        if (trigger) trigger.setAttribute('aria-expanded', 'false')
        if (menu) menu.hidden = true
      })
    }

    fields.forEach(function (field) {
      var trigger = field.querySelector('.spb-field__trigger')
      var menu = field.querySelector('.spb-field__menu')
      var kind = field.dataset.field
      if (!trigger || !menu) return

      trigger.addEventListener('click', function (e) {
        e.stopPropagation()
        var isOpen = trigger.getAttribute('aria-expanded') === 'true'
        closeAll(field)
        trigger.setAttribute('aria-expanded', String(!isOpen))
        menu.hidden = isOpen
      })

      // The style-group field's options are real links to sibling product
      // pages (see fieldList comment above) — let them navigate natively
      // instead of running the variant-selection logic.
      if (field.dataset.optionIndex === undefined) return

      menu.querySelectorAll('.spb-field__option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          selectValue(field, kind, opt)
          trigger.setAttribute('aria-expanded', 'false')
          menu.hidden = true
        })
      })
    })

    // Close on outside click / Esc
    document.addEventListener('click', function (e) {
      if (!bar.contains(e.target)) closeAll(null)
    })
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null)
    })

    // Initial paint: gray out anything unavailable given the pre-selected
    // color, and set the button/id/dot to match.
    refreshAvailability()
    refreshSubmit()
  }

  function initAll() {
    document.querySelectorAll('sticky-product-bar').forEach(initBar)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll)
  } else {
    initAll()
  }

  // Re-init when edited in the theme customizer
  document.addEventListener('shopify:section:load', initAll)
})()
